/**
 * v1.1
 */

// 懒加载
import { lazy }  from 'react'
// // 重定向
import { Navigate } from 'react-router-dom'
//
// import Home from '@/pages/Home'
// import TestAnimeSearch from '@/pages/Test/TestAnimeSearch/TestAnimeSearch.jsx'
// import TestAxios from '@/pages/Test/TestAxios'
// import DemoReduxCounter from '@/pages/Test/DemoRedux/Counter.js'
//
import RequireAuth from '@/pages/Login/Auth/RequireAuth.jsx'
// 改成懒加载
const Home = lazy(()=> import('@/pages/Home'))
const Music = lazy(()=> import('@/pages/Music'))
const Article = lazy(()=> import('@/pages/Article'))
const Login = lazy(()=> import('@/pages/Login'))
const UserInfo = lazy(()=> import('@/pages/UserInfo'))
const About = lazy(()=> import('@/pages/About'))
const Test = lazy(()=> import('@/pages/Test'))
const Ipfs = lazy(()=> import('@/pages/Ipfs'))
const MusicList = lazy(()=> import('@/components/MusicList'))
//
const routes = [
    
    {
        path: '',
        element: <Home />
    },
    {
        path: 'home',
        element: <Home />
    },
    {
        path: 'article',
        element: <Article />,
    },
    { path:'article/:path', element:<Article /> },
    { path:'article/:path/:path',  element:<Article /> },
    {
        path: 'ipfs',
        element: <Ipfs />,
        children:[
            {path:'music', element:<MusicList/>},
            {path:'/ipfs', element:<Navigate to="music"/>}  // 在进入ipfs页面时，默认加载到子路径music
        ]
    },
    {
        path: 'music',
        element: 
        <RequireAuth>
            <Music />
        </RequireAuth>
    },
    {
        path: 'login',
        element: <Login />
    },
    {
        path: 'userinfo',
        element: <UserInfo />
    },
    {
        path: 'about',
        element: <About />
    },
    {
        path: 'test',
        element: <Test />
    },
    // {path: 't1', element: <TestAnimeSearch />},
    // {path: 't2', element: <TestAxios />},
    // {path: 't3', element: <DemoReduxCounter />},
]

export default routes